module.exports = __webpack_public_path__ + "img/trx-after-new.c48e233e.jpg";